document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('.klaviyo_form_trigger')
    .forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const klaviyoFormOpen = document.querySelector(
          '.klaviyo-form[data-testid]:not([style*="display: none"])',
        );
        if (klaviyoFormOpen) return;
        const formId = trigger.getAttribute('data-form-id');
        if (!formId) return;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      });
    });
});
